import React from 'react';
import ContactForm from "./ContactForm";
import MeetingForm from "./MeetingForm";
import {DateTimeProvider} from "../contexts/DateTimeContext";
import {GlobalProvider} from "../contexts/Provider";
import FormHeader from "./FormHeader";
import FormContactUs from "./FormContactUs";

const Form = (props) => {
    const availableMeetingForm = props.productId || props.categoryId;

    return (
        <GlobalProvider stores={props.stores}
                        productId={props.productId}
                        categoryId={props.categoryId}
                        availableMeetingForm={availableMeetingForm}
                        initialStoreId={props.storeId}
        >
            <div className="contact-form__content bg-black">
                <div className="relative flex flex-col lg:flex-row lg:gap-12 mx-auto justify-center start">

                    <div className="w-full lg:w-1/2 p-0 md:pr-32">
                        <FormHeader />

                        <FormContactUs />
                    </div>

                    <div className="w-full lg:w-1/2 text-white product-form-placeholder">
                        <ContactForm props={props} />
                        {availableMeetingForm && (
                            <DateTimeProvider>
                                <MeetingForm props={props} />
                            </DateTimeProvider>
                        )}
                    </div>
                </div>
            </div>

        </GlobalProvider>
    );
};

export default Form;
